import { useContext, useEffect } from "react";
import { Footer } from "src/molecules/Footer";
import { Header } from "src/organisms/Header";
import { ShopTypeDispatch } from "src/contexts/shop-type.context";
import { Modal } from "src/atoms/Modal";
import { ScreenLoader } from "src/molecules/ScreenLoader";
import { useRouter } from "next/router";
import layout from "src/styles/layout.module.scss";

export default function LoginPages({
  children,
}: {
  children: JSX.Element;
}): JSX.Element {
  const dispatch = useContext(ShopTypeDispatch);

  useEffect(() => {
    dispatch?.({ type: "SET_SHOP_TYPE", payload: "women" });
  }, [dispatch]);

  const router = useRouter();
  const { query } = router;
  const openScreenLoader = query.signin;

  return (
    <>
      <main className={layout.gridRoot}>
        {openScreenLoader === "true" && (
          <Modal onClose={() => {}} overFlow={"visible"} isOpen={true}>
            <ScreenLoader />
          </Modal>
        )}
        <Header isLoginFlow />
        {children}
        <Footer />
      </main>

      <div id="portal" />
      <div id="overlay-portal" />
    </>
  );
}
